module.exports = __webpack_public_path__ + "console/img/feedback.f6b73c43.svg";